module.exports = __webpack_public_path__ + "static/media/services_drycleaning.1f7949b7.jpg";